import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { Stadium, StadiumLog } from "@/modules/stadium/entity";
export default /*#__PURE__*/_defineComponent({
  __name: 'StadiumLogLoader',
  props: {
    match: null
  },
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const stadium = ref();
    const stadiumLog = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      stadium.value = await Stadium.createQueryBuilder('stadium').innerJoinAndSelect('stadium.team', 'team').innerJoinAndSelect('stadium.terraces', 'terrace').where('team.id = :teamId', {
        teamId: props.match.homeTeam.id
      }).getOneOrFail();
      stadiumLog.value = await StadiumLog.createQueryBuilder('stadiumLog').innerJoin('stadiumLog.match', 'match').innerJoinAndSelect('stadiumLog.terraceLogs', 'terraceLog').where('match.id = :matchId', {
        matchId: props.match.id
      }).getOneOrFail();
    })), __temp = await __temp, __restore(), __temp);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({
        stadium: stadium.value,
        stadiumLog: stadiumLog.value
      })))]);
    };
  }
});